module.exports = __webpack_public_path__ + "img/thank-imglogo0.55608148.png";